<template>

    <div class="bg-greyTanFour pricing">
        <div class="mt-8 lg:mt-0 px-6 py-4 lg:py-8">
            <button class="w-full flex justify-center lg:hidden " @click="mobileOpen = !mobileOpen" style="display:flex"
                    v-if="isMobileClosedMenuWithAddOns || isMobileOpenMenuWithAddOns ">

                <!-- "Close" SVG -->
                <svg v-if="mobileOpen" width="17" class="mb-4 lg:hidden" height="7" viewBox="0 0 17 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16.5 0.907104L8.5 5.9071L0.5 0.907103" stroke="#333740" stroke-width="0.87"/>
                </svg>

                <!-- "Open" SVG -->
                <svg v-else class="lg:hidden" width="18" height="7" viewBox="0 0 18 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 6.5L9 1.5L17 6.5" stroke="#333740" stroke-width="0.87"/>
                </svg>

            </button>
            <div
                 :class="{'divide-y divide-offBlack' : isEnquireViewWithAddOns || isMobileOpenMenuWithAddOns, 'lg:divide-y lg:divide-offBlack' : (this.addOns?.length || this.addOnsHtml) }">
                <div class="flex lg:flex-col align-middle lg:block"
                     :class="{'hidden' : isMobileClosedMenuWithAddOns, 'flex-col' : viewProductEnabled}">
                    <div class="flex lg:w-full lg:mb-8 lg:mr-0 my-auto lg:block"
                         :class="{
                            'hidden': isMobileOpenMenuWithAddOns,
                            'w-1/5 mr-2' : isMobileClosedMenuNoAddOns ,
                            'mb-8' : viewProductEnabled
                        }">
                        <img :src="product.image" :alt="product.title"
                              class="w-full self-end lg:mb-0"
                             :class="{'w-3/4 mx-auto' : viewProductEnabled}">
                    </div>
                    <div class="lg:w-full flex flex-col justify-center "
                         :class="{
                            'w-4/5' : isMobileClosedMenuNoAddOns,
                            'w-full' : isMobileOpenMenuWithAddOns || viewProductEnabled,
                            'mb-4' : (addOnsHtml || addOns.length)
                        }">
                        <h6 id="configurator-product-title">{{ product.title }} {{ customisationtype }}</h6>
                        <p id="configurator-product-id" class="hidden">{{ product.id }}</p>
                        <div class="flex justify-between lead base-price align-end">
                            <p class="mb-0">Base price</p>
                            <p class="" id="configurator-product-baseprice"
                               :class="{
                                    'text-center': removeOptionEnabled,
                                    'text-right': !removeOptionEnabled,
                                    'lg:mr-2' : addOns.length >= 3
                            }">{{ basePrice }}</p>
                        </div>
                    </div>

                </div>
                <div v-if="addOnsHtml || addOns.length" :class="{'hidden lg:block' : isMobileClosedMenuWithAddOns}">
                    <div class="my-4">
                        <div ref="addonsWrapper"
                             :class="{'lg:max-h-72 overflow-auto' : addOns.length && !viewProductEnabled}">
                            <div v-if="addOnsHtml" v-html="addOnsHtml"></div>
                            <div v-else v-for="(addOn) in addOns" class="flex mb-4 last:mb-0 addOns-customiser">
                                <div class="w-3/4 pr-6"><a :href="'#' + addOn.categoryId">{{ addOn.title }}</a></div>
                                <div class="w-1/4" :class="{'lg:mr-2' : addOns.length >= 3}">
                                    <div class="w-full"
                                         :class="{
                                            'text-right': !removeOptionEnabled, // the 'remove' button will not be shown, so the text is going to the right
                                            'flex justify-between': removeOptionEnabled // the 'remove' button will be shown, so lets make a space between it and the price
                                        }">
                                        <div>{{ formatPrice(addOn.price) }}</div>
                                        <div v-if="removeOptionEnabled" class="cursor-pointer" title="Remove"
                                             @click="$emit('removeAddOn', addOn.id)">
                                            <svg width="20" height="21" viewBox="0 0 20 21" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <path fill="black"
                                                      d="M0 10.5C0 4.99219 4.45312 0.5 10 0.5C15.5078 0.5 20 4.99219 20 10.5C20 16.0469 15.5078 20.5 10 20.5C4.45312 20.5 0 16.0469 0 10.5ZM6.5625 9.5625C6.01562 9.5625 5.625 9.99219 5.625 10.5C5.625 11.0469 6.01562 11.4375 6.5625 11.4375H13.4375C13.9453 11.4375 14.375 11.0469 14.375 10.5C14.375 9.99219 13.9453 9.5625 13.4375 9.5625H6.5625Z"
                                                />
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="flex justify-between items-end mt-4 lead base-price mb-0 "
                         v-if="addOnsHtml || addOns.length">
                        <img :src="product.image" class="w-1/5 block lg:hidden self-center"
                             :class="{'hidden' : viewProductEnabled}">
                        <p class="mb-0 mr-auto ml-2 lg:ml-0">Total <span class="block md:inline">estimated price</span>
                        </p>
                        <p class="text-gold total-price" id="configurator-product-totalprice"
                           :class="{'text-center': removeOptionEnabled, 'text-right': !removeOptionEnabled, 'mr-2' : addOns.length >= 3}">
                            {{ totalPrice }}</p>
                    </div>
                </div>
            </div>

        </div>

        <div class="btn-wrap lg:mb-6 flex justify-center align-middle items-center lg:gap-6"
             :class="{'pb-8 flex-col ' : viewProductEnabled, 'lg:flex-column' : product.brochureUrl, ' lg:flex-row' : !product.brochureUrl }">
            <button v-if="enquireOptionEnabled" @click="$emit('enquire')"
                    class="button primary-alternate lg:w-auto"
                    :class="{
                        'w-1/2' : addOns.length,
                        'w-full' : !addOns.length
                    }">
                <span>Enquire</span>
            </button>
            <button class="button primary black flex justify-center gap-2 lg:gap-4 w-1/2 lg:w-auto"
                    v-if="startOverEnabled && addOns.length"
                    @click="$emit('startOver')">
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M22.0117 12.1133L21.9609 12.0625C21.7578 12.0625 21.6055 12.2148 21.5547 12.4688C20.9961 17.5469 16.6289 21.4062 11.5 21.4062C7.13281 21.4062 3.27344 18.6133 1.90234 14.5H7.84375C8.04688 14.5 8.25 14.3477 8.25 14.0938C8.25 13.8906 8.04688 13.6875 7.84375 13.6875H0.9375C0.683594 13.6875 0.53125 13.8906 0.53125 14.0938V20.5938C0.53125 20.8477 0.683594 21 0.9375 21C1.14062 21 1.34375 20.8477 1.34375 20.5938V15.3125C2.96875 19.4258 6.98047 22.2188 11.5 22.2188C17.0352 22.2188 21.7578 18.0547 22.3672 12.5195C22.418 12.3164 22.2148 12.1133 22.0117 12.1133ZM22.0625 1.5C21.8086 1.5 21.6562 1.70312 21.6562 1.90625V7.23828C19.9805 3.125 15.9688 0.28125 11.5 0.28125C5.91406 0.28125 1.19141 4.49609 0.582031 10.0312C0.53125 10.2344 0.734375 10.4375 0.9375 10.4375H0.988281C1.19141 10.4375 1.34375 10.2852 1.39453 10.082C1.95312 5.00391 6.32031 1.09375 11.5 1.09375C15.8164 1.09375 19.6758 3.9375 21.0469 8H15.1562C14.9023 8 14.75 8.20312 14.75 8.40625C14.75 8.66016 14.9023 8.8125 15.1562 8.8125H22.0625C22.2656 8.8125 22.4688 8.66016 22.4688 8.40625V1.90625C22.4688 1.70312 22.2656 1.5 22.0625 1.5Z"
                                fill="#333740"/>
                        </svg>
                        <span>Start over</span>
            </button>
            <a v-if="product.brochureUrl" target="_blank" class="button primary flex gap-4 mt-6 lg:mt-0"
               :href="product.brochureUrl">Download brochure</a>
            <a v-if="viewProductEnabled" target="_blank" class="button primary flex gap-4  mt-6 lg:mt-0"
               :href="product.url" :class="{'black' : product.brochureUrl}">View {{ product.title2 ? product.title2 : product.title }}</a>

            <button v-if="canEdit && viewProductEnabled && addOns.length" class=" button-alternate text-gold  ml-4 mt-6 lg:mt-0"
                    @click="$emit('keepEditing')">Keep customising
            </button>

        </div>
    </div>

</template>

<script>
import {ref} from 'vue'
import {formatPrice} from './Functions'

export default {
    props: {
        product: {
            required: true
        },
        customisationtype: {
            required: false
        },
        addOns: {
            required: false,
            default: []
        },
        addOnsHtml: {
            required: false
        },
        totalpriceformatted: {
            required: false
        },
        basepriceformatted: {
            required: false
        },
        startOverEnabled: {
            required: true
        },
        removeOptionEnabled: {
            required: true
        },
        enquireOptionEnabled: {
            required: true
        },
        viewProductEnabled: {
            required: true
        },
    },
    name: "Summary",
    methods: {
        formatPrice(price) {
            return formatPrice(price)
        },
    },
    computed: {
        totalPrice() {

            if (this.totalpriceformatted) {
                return this.totalpriceformatted
            } else {
                return formatPrice(this.product.price + (this.addOns.reduce((accumulator, object) => {
                    return accumulator + object.price;
                }, 0) * 1))
            }

        },
        basePrice() {

            if (this.basepriceformatted) {
                return this.basepriceformatted
            } else {
                return formatPrice(this.product.price)
            }

        },
        isEnquireViewWithAddOns() {
            return (this.addOns?.length || this.addOnsHtml) && this.viewProductEnabled
        },
        isMobileOpenMenuNoAddOns() {
            return this.mobileOpen && !this.addOns?.length && !this.viewProductEnabled
        },
        isMobileOpenMenuWithAddOns(){
            return this.mobileOpen && this.addOns?.length && !this.viewProductEnabled
        },
        isMobileClosedMenuNoAddOns() {
            return !this.mobileOpen && !this.addOns?.length && !this.viewProductEnabled
        },
        isMobileClosedMenuWithAddOns(){
            return !this.mobileOpen && this.addOns?.length && !this.viewProductEnabled

        }
    },
    updated() {
        if (this.addOns?.length) {
            this.$refs.addonsWrapper.scrollTop = this.$refs.addonsWrapper.scrollHeight;
        } else {
            this.mobileOpen = false
        }
    },
    setup(props) {

        const canEdit = ref(true);
        const mobileOpen = ref(false);

        if (props.viewProductEnabled) {

            const myForm = document.getElementById("productConfigurator");
            myForm?.addEventListener("freeform-ajax-success", function (event) {
                canEdit.value = false;
                console.log(event)

                // send to hubspot here
                let submissionId = event?.response?.submissionId

                if (submissionId) {
                    let submissionUrl = window.location.origin + "/customise/submission/" + submissionId
                    console.log(submissionUrl)
                }

            });
        }
        return {
            canEdit,
            mobileOpen
        }
    },
}
</script>